import useGTM from '@/lib/hook/useGTM';
import { Helmet } from 'react-helmet-async';
import { useEffect, type FC } from 'react';
import { useLocation } from 'react-router-dom';
import { Cookies } from 'react-cookie-consent';
import { useTenantRoute } from '@/account/hook/useTenantRoute';
import CookieBanner from '@/base/App/CookieBanner';

const script = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','{{gtmKeys}}');`;

interface GTMProps {
  children: React.ReactNode
}

const ProviderGTM: FC<GTMProps> = ({ children }) => {
  const { tenantCode } = useTenantRoute();
  const isConsentGiven = Cookies.get(`CookieConsent-${tenantCode}`) === 'true';
  const isGTMAdded = () => {
    const scripts = document.querySelectorAll('script');
    return Array.from(scripts).some(
      (scriptElement) => { return scriptElement.src.includes('https://www.googletagmanager.com/gtm.js'); }
    );
  };
  const { data, sendGTMEvent } = useGTM();
  const location = useLocation();

  useEffect(() => {
    sendGTMEvent('pageView', { page: location.pathname });
  }, [location.pathname, sendGTMEvent, isConsentGiven]);

  return (
    <>
      {isConsentGiven && !isGTMAdded() && data?.item?.googleTagManagerKey && <Helmet>
        <script>
          {script.replace('{{gtmKeys}}', data?.item?.googleTagManagerKey)}
        </script>
        <noscript>
          {
            `<iframe src="https://www.googletagmanager.com/ns.html?id=${data?.item?.googleTagManagerKey}"
            height="0" width="0" style="display:none;visibility:hidden"></iframe>`
          }
        </noscript>
      </Helmet>}
      <CookieBanner data={data} sendGTMEvent={sendGTMEvent} isGivenCookieConsent={isConsentGiven} />
      {children}
    </>
  );
};

export default ProviderGTM;
